import { useCustomField } from './useCustomField'

export const useFieldError = (name, config) => {
  return useCustomField(name, {
    subscription: { touched: config.touched, error: true, submitError: true, dirtySinceLastSubmit: true }
  })
}
